import React from "react";
import * as S from "./style";

interface FilterBarProps {
  themes: string[];
  selectedTheme: string | null;
  onFilter: (theme: string | null) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  themes,
  selectedTheme,
  onFilter,
}) => {
  return (
    <S.FilterBar>
       <S.FilterButton
        key="all"
        onClick={() => onFilter(null)}
        isSelected={selectedTheme === null}
      >
        Tutti
      </S.FilterButton>
      {themes.map((theme) => (
        <S.FilterButton
          key={theme}
          onClick={() => onFilter(theme === "Tutti" ? null : theme)}
          isSelected={selectedTheme === theme}
        >
          {theme}
        </S.FilterButton>
      ))}
    </S.FilterBar>
  );
};

export default FilterBar;